module.exports = __webpack_public_path__ + "1d07a8b84f27401d15e2578801e366a5.svg";